import { api } from "../Api/api";

export interface ConfirmRequest {
  // Não precisa mais de campos - o sessionId vem do header
}

export interface ConfirmResponse {
  // ✅ Com redirecionamento direto, não retorna JSON
  // O servidor faz redirect HTTP 302
  success: boolean;
  message?: string;
}

export interface ConfirmRedirectRequest {
  sessionId: string;
}

export interface ConfirmRedirectResponse {
  success: boolean;
  message?: string;
  redirectUrl?: string;
}

export interface ActivateSecondViewRequest {
  // Adicione aqui os campos necessários para ativar a segunda tela
}

export interface ActivateSecondViewResponse {
  success: boolean;
  message?: string;
}

// Função para ativar segunda tela
export const activateSecondView = async (
  request: ActivateSecondViewRequest
): Promise<ActivateSecondViewResponse> => {
  try {
    const response = await api.post<ActivateSecondViewResponse>(
      "/auth/activate-second-view",
      request
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao ativar segunda tela:", error);
    throw error;
  }
};

// ✅ Função para confirmar redirecionamento - OPÇÃO 1: window.location (Recomendada)
export const confirmRedirectWithWindowLocation = (sessionId: string): void => {
  try {
    // ✅ Usar window.location.href para redirecionamento direto
    // O navegador seguirá automaticamente o HTTP 302
    const redirectUrl = `${api.defaults.baseURL}/auth/confirm-redirect?sessionId=${encodeURIComponent(sessionId)}`;
    
    console.log("Redirecionando para:", redirectUrl);
    window.location.href = redirectUrl;
  } catch (error) {
    console.error("Erro ao redirecionar:", error);
    throw error;
  }
};

// ✅ Função para confirmar redirecionamento - OPÇÃO 2: fetch com controle manual
export const confirmRedirectWithFetch = async (
  sessionId: string
): Promise<ConfirmRedirectResponse> => {
  try {
    const url = `${api.defaults.baseURL}/auth/confirm-redirect?sessionId=${encodeURIComponent(sessionId)}`;
    
    // ✅ Configurar fetch para seguir redirecionamentos
    const response = await fetch(url, {
      method: 'GET',
      redirect: 'follow', // Seguir redirecionamentos automaticamente
      credentials: 'include', // Incluir cookies se necessário
    });

    // ✅ Se chegou até aqui, o redirecionamento foi seguido
    if (response.ok) {
      return {
        success: true,
        message: "Redirecionamento realizado com sucesso",
        redirectUrl: response.url, // URL final após redirecionamento
      };
    } else {
      throw new Error(`Erro HTTP: ${response.status}`);
    }
  } catch (error: any) {
    console.error("Erro ao confirmar redirecionamento:", error);
    
    // ✅ Se for erro de rede, pode ser que o redirecionamento tenha funcionado
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      return {
        success: true,
        message: "Redirecionamento pode ter sido realizado",
      };
    }
    
    throw error;
  }
};

// ✅ Função para confirmar ativação - ATUALIZADA
export const confirmActivation = async (): Promise<ConfirmResponse> => {
  try {
    // ✅ Com redirecionamento direto, o servidor retorna HTTP 302
    // O axios/fetch seguirá o redirect automaticamente
    await api.post<ConfirmResponse>(
      "/auth/confirm",
      {},
      {
        // ✅ Configurações para seguir redirecionamentos
        maxRedirects: 5, // Seguir até 5 redirecionamentos
        validateStatus: (status) => {
          // ✅ Aceitar status 200, 302, etc.
          return status >= 200 && status < 400;
        },
      }
    );

    // ✅ Se chegou até aqui, foi redirecionado com sucesso
    return {
      success: true,
      message: "Redirecionamento realizado com sucesso",
    };
  } catch (error: any) {
    console.error("Erro ao confirmar ativação:", error);

    // ✅ Tratar diferentes tipos de erro
    if (error.response?.status === 302) {
      // Redirecionamento - não é erro
      return {
        success: true,
        message: "Redirecionamento realizado",
      };
    }

    throw error;
  }
};
